import type { SVGProps } from "react";
export interface HeadSettingsIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function HeadSettingsIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: HeadSettingsIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M11.204 4.375c.887 0 1.605.71 1.622 1.594a1.625 1.625 0 0 1 2.104.468l.09.141.704 1.219.076.148A1.624 1.624 0 0 1 15.155 10c.71.427.979 1.313.645 2.055l-.077.148-.703 1.219a1.624 1.624 0 0 1-2.194.608 1.623 1.623 0 0 1-1.622 1.595H9.795a1.624 1.624 0 0 1-1.623-1.595c-.724.4-1.626.192-2.102-.467l-.09-.141-.704-1.219A1.623 1.623 0 0 1 5.846 10a1.623 1.623 0 0 1-.57-2.203l.703-1.219.091-.14a1.625 1.625 0 0 1 2.102-.47 1.624 1.624 0 0 1 1.623-1.593zm-.543 4.058a1.576 1.576 0 1 1-1.728 1.728L8.925 10l.008-.161A1.575 1.575 0 0 1 10.5 8.425zm-2.408 1.696a1.68 1.68 0 0 1-.72 1.482l.086.151a1.67 1.67 0 0 1 1.46.013l.187.107.222.13c.474.239.877.728.924 1.363h.176c.047-.635.45-1.124.924-1.364l.221-.129.188-.107a1.67 1.67 0 0 1 1.459-.013l.086-.15a1.68 1.68 0 0 1-.719-1.483l.004-.129q0-.065-.004-.129a1.68 1.68 0 0 1 .72-1.484l-.087-.15a1.68 1.68 0 0 1-1.647-.12 2 2 0 0 0-.22-.128 1.68 1.68 0 0 1-.925-1.364h-.176a1.68 1.68 0 0 1-.924 1.364q-.115.058-.222.129a1.68 1.68 0 0 1-1.647.118l-.087.151c.527.358.75.953.72 1.484a2 2 0 0 0 0 .258Z"
      />
      <path
        fill={color}
        d="M2.875 22v-3.81c0-.863-.331-1.396-.882-2.505C1.446 14.585.875 13.207.875 11 .875 5.14 5.141.875 11 .875c4.878 0 8.384 3.602 9.519 7.945l.364 1.396c.365 1.353.758 2.573 1.442 3.642l.414.646.088.15c.85 1.548-.193 3.496-1.995 3.609l-.813.05-.212 2.014a3.124 3.124 0 0 1-3.107 2.797H14A4.125 4.125 0 0 1 9.875 19a1.125 1.125 0 0 1 2.25 0c0 1.035.84 1.875 1.875 1.875h2.7a.875.875 0 0 0 .87-.783l.223-2.12.029-.19a2.125 2.125 0 0 1 1.95-1.708l.92-.057.052-.01a.196.196 0 0 0 .122-.242l-.022-.048-.415-.646c-1.147-1.794-1.622-3.9-2.087-5.68-.943-3.608-3.728-6.266-7.342-6.266-4.617 0-7.875 3.258-7.875 7.875 0 1.745.429 2.772.882 3.684.449.903 1.118 1.99 1.118 3.507V22a1.125 1.125 0 0 1-2.25 0"
      />
    </svg>
  );
}
